// import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'

import soundoff from "assets/side_pane_new_icons/volumemute.svg";
import soundon from "assets/side_pane_new_icons/volume.svg";
import reload from "assets/side_pane_new_icons/refresh.png";

import notification from "assets/side_pane_new_icons/bell.svg";
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import unetLogo from 'assets/img/chu.svg'
import unetLogoB from 'assets/img/chu.svg'

import { getAlertData } from "service/AlertService";
import { setAlertById } from "store/slices/AlertSlice";

import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import AlertPopOver from 'pages/MainPage/components/AlertCard/AlertPopOver'
import PersonalMenuCard from 'pages/ProfilePage/PersonalMenu/PersonalMenuCard'
import { useEffect, useState } from 'react'
import Moment from 'react-moment'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ScaleLoader } from 'react-spinners'
import { getAllServices, ChangeTheme } from 'service/TariffService'
import { setMyTariff } from 'store/slices/TariffSlice'
import { changeThemeAction } from 'store/slices/UserSlice'
import useSWR from 'swr'
import DynamicAvatar from 'utils/DynamicAvatar'
import MessageNotification from 'utils/MessageNotification'

import userInfo from 'utils/userInfo'
import chat from "assets/side_pane_new_icons/messages.svg";

import sun from "assets/icons/sun.png";
import MenuDrawerMobile from '../Sidebar/components/Menu/MenuDrawerMobile'
import stylesB from './Header.module.scss'
import stylesW from './HeaderW.module.scss'
import { getImage } from "service/BackgroundService";






function Header({ width, setBackgroundImage }) {

  const [currentDynamicAvatar, getDynamicAvatar] = useState()
  const navigate = useNavigate()
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  })
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const initialMuteStatus = localStorage.getItem('mute') === 'true'
  const [muteStatus, setMuteStatus] = useState(initialMuteStatus)

  const handleSwitchMute = () => {
    const newMuteStatus = !muteStatus
    setMuteStatus(newMuteStatus)
    localStorage.setItem('mute', newMuteStatus.toString())
  }

  const user = userInfo()
  useEffect(() => {
    if (!user.userId) {
      navigate("/"); // перекидывает на главную
    }
  }, [user, navigate]);
  const [styles, setThem] = useState(stylesB)

  function notificationsLabel(count) {
    if (count === 0) {
      return 'no notifications'
    }
    if (count > 99) {
      return 'more than 99 notifications'
    }
    return `${count} notifications`
  }
  let data;
  const dispatch = useDispatch()
  const [text, setText] = useState(false)
  const getData = async () => {
   
    try {
      let response = await getAlertData(user.userId, data);
      dispatch(
        setAlertById({
          alerts: response.data,
        })
      );
    } catch (error) {

    }
  };
  useEffect(() => {

    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
    getData();
  }, []);

  const alert = useSelector((state) => state.alert.alerts)
  const messages = useSelector((state) => state.alert.alertsMessages)


  const {
    data: response,
    error,
    isValidating: isLoading,
  } = useSWR('/subscription/', getAllServices)

  if (response) {
    dispatch(
      setMyTariff({
        myTariff: response.data.services,
      }),
    )
  } else if (error) {
    console.log("CHU")
  }

  const ReRenderWindow = async () => {
    try {

    
      window.location.reload()
    } catch (error) {
      console.log("CHU")
    }
  }



  // const myTariffInfo = useSelector((state) => state.tariff.myTariff)
  // console.log(myTariffInfo)
  let all_alerts = [...alert, ...messages]
  useEffect(() => {

    all_alerts = [...alert, ...messages]
  }, [alert, messages])

 


  const handleChangeTheme = async () => {

    let response = await ChangeTheme()
    dispatch(changeThemeAction(response.data),)
    let response3 = await getImage(data);
    let userData = JSON.parse(localStorage.getItem('user'));


    if (userData?.them === false) {
      userData.userInfo.them = true;
      userData.them = true;
      localStorage.setItem("background", 'white');
    }

    else {
      userData.userInfo.them = false;
      userData.them = false;
      localStorage.setItem("background", response3.data?.file);
    }

    localStorage.setItem('user', JSON.stringify(userData));



    window.location.reload()
  }

  return (
    <>
      <div className={styles.header__wrapper}>
        {width >= 769 ? (
          <div onClick={() => navigate('/home/')} className={styles.logo__wrapper}><img className={styles.img} src={unetLogo} /></div>
        ) : (
          <MenuDrawerMobile width={width} />
        )}
          
        <p className={styles.date_interval}>
          <Moment format="HH:mm:ss" interval={1000} />
        </p>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100px',
            }}
          >
            <ScaleLoader color="black" size={10} />
          </div>
        ) : (
          text ? (
            <span
              className={styles.tariff_btn}
              onClick={() => navigate('/tarif/')}
              style={{
                background:
                  'linear-gradient(181deg, rgb(57 55 55 / 86%) -19.07%, rgb(0 0 0) 162.38%)',
                color: 'white',
              }}
            >
              Сервисы
            </span>
          ) : null
        )}
       
        {/* <IconButton >
         
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', cursor: "pointer" }}
              onClick={ReRenderWindow}
            >
              <img src={reload} alt="" onClick={ReRenderWindow} className={styles.imgchat} />
            </div>

        
        </IconButton> */}

        <IconButton >
          {muteStatus ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', cursor: "pointer" }}
              onClick={handleSwitchMute}
            >
              <img src={soundoff} alt="" onClick={handleSwitchMute} className={styles.imgchat} />
            </div>

          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', cursor: "pointer" }}
              onClick={handleSwitchMute}
            >
              <img src={soundon} alt="" onClick={handleSwitchMute} className={styles.imgchat} />
            </div>
          )}
        </IconButton>
      
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState2) => (
            <>

              <div className={styles.alerts}>

                <div style={{ display: "flex", alignItems: "center", padding: '4px', justifyContent: 'center', cursor: "pointer" }}
                  aria-label={notificationsLabel(100)}
                  {...bindTrigger(popupState2)}
                > <Badge
                  badgeContent={all_alerts.length}
                  color="primary"
                  style={{ zIndex: '0' }}
                >

                    <img src={notification} alt="" className={styles.imgchat} />
                  </Badge>
                </div>


              </div>



              <Popover
                {...bindPopover(popupState2)}
                style={{
                  backgroundColor: '95%',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <AlertPopOver />
              </Popover>
            </>
          )}
        </PopupState>



          {/* <div style={{ display: "flex", alignItems: "center", padding: '4px', justifyContent: 'center', cursor: "pointer" }}
            onClick={() => navigate(`/chats/`)}
          >
            <img src={chat} alt="" className={styles.imgchat} />
          </div> */}
   
        {user?.them ?

          ""
          : <div style={{ display: "flex", alignItems: "center", padding: '4px', justifyContent: 'center', cursor: "pointer" }}
            onClick={() => handleChangeTheme()}
          >
            <img src={sun} alt="" className={styles.imgchat} />
          </div>}
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <>
              <div className={styles.user__wrapper}>
                <div className={styles.avatar2} {...bindTrigger(popupState)}>
                  <img
                    src={currentDynamicAvatar?.imeag}
                    alt=""
                    className={styles.image__cover}
                  />
                </div>
              </div>

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {/* <ProfilePage /> */}
                <PersonalMenuCard setBackground={setBackgroundImage} />
              </Popover>
            </>
          )}
        </PopupState>
      </div>
   
      <MessageNotification notify={notify} setNotify={setNotify} />
      <DynamicAvatar getDynamic={getDynamicAvatar} />
    </>
  )
}

export default Header
